import { getBasePath } from '../../utils/config';
import { safeJsonParse, buildUrl } from 'api/utils/fetchHelpers';
import { TPointsOfSaleToUpdateRequest } from 'interfaces/clients.interface';
import * as clientType from 'api/endpoints/clients/clients.response.interface';

export const getAssociationsAPI = async ({
  tenantId,
  token,
}: {
  tenantId: string;
  token: string;
}): Promise<clientType.TGetAssociationsResponseAPI> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/get_association_requests`, {
      tenant_id: tenantId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const getBrandPointsOfSaleAPI = async (
  aliasId: string,
  token: string
): Promise<clientType.TGetBrandPointsOfSaleAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/get_alias_points_of_sale`, {
      client_alias_id: aliasId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const getClientProfileAPI = async (
  clientId: string,
  token: string
): Promise<clientType.TGetClientProfileResponseAPI> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/get_client_profile`, {
      client_id: clientId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const getClientPointsOfSaleAPI = async (
  clientId: string,
  token: string
): Promise<clientType.TGetClientPointsOfSaleResponseAPI> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/get_client_points_of_sale`, {
      client_id: clientId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const createClientAliasAPI = async ({
  client,
  token,
}: {
  client: clientType.IcreateClientAliasAPIBody;
  token: string;
}): Promise<clientType.IcreateClientAliasAPIResponse> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(client),
  };
  const response = await fetch(
    `${getBasePath()}/brand_profile/create_client_alias`,
    params
  );
  return await safeJsonParse(response);
};

export const deleteClientAliasAPI = async ({
  clientAliasId,
  token,
}: {
  clientAliasId: string;
  token: string;
}): Promise<clientType.IremoveClientAliasAPIResponse> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      aliases_id: [clientAliasId],
    }),
  };
  const response = await fetch(`${getBasePath()}/brand_profile/delete_alias`, params);
  return await safeJsonParse(response);
};

export const updateClientAPI = async ({
  clientId,
  client,
  token,
}: {
  clientId: string;
  client: Partial<clientType.IupdateClientAPIBody>;
  token: string;
}): Promise<clientType.IupdateClientAPIResponse> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      client_alias_id: clientId,
      update: client,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/brand_profile/update_client_alias`,
    params
  );
  return await safeJsonParse(response);
};

export const createPointOfSaleAPI = async (body: any, token: string): Promise<any> => {
  const params = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/brand_profile/create_point_of_sale`,
    params
  );
  return await safeJsonParse(response);
};

// export const updatePointOfSaleAPI = async (body: any, token: string): Promise<any> => {
//   const params = {
//     method: "PATCH",
//     headers: {
//       Authorization: `Bearer ${token}`,
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(body)
//   }
//   const response = await fetch(`${getBasePath()}/association/update_brand_point_of_sale`, params)
//   const data = await response.json()
//   return { response, data }
// }

export const updatePointOfSaleAPI = async (body: any, token: string): Promise<any> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    `${getBasePath()}/brand_profile/update_point_of_sale`,
    params
  );
  return await safeJsonParse(response);
};

export const removePointOfSaleAPI = async (
  pointOfSaleId: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      points_of_sale_id: [pointOfSaleId],
    }),
  };
  const response = await fetch(
    `${getBasePath()}/brand_profile/delete_point_of_sale`,
    params
  );
  return await safeJsonParse(response);
};

export const associateClientAPI = async (
  body: any,
  tenantId: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/associate`, { tenant_id: tenantId }),
    params
  );
  return await safeJsonParse(response);
};

export const detachAssociationAPI = async (
  associationId: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/delete_association_with_client`, {
      association_id: associationId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const getPointsOfSaleCategoriesAPI = async ({
  token,
}: {
  token: string;
}): Promise<clientType.IGetPointOfSaleCategoriesAPI> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/get_point_of_sale_category`,
    params
  );
  return await safeJsonParse(response);
};

export const getPointsOfSaleAssociationsAPI = async ({
  clientAliasId,
  token,
}: {
  clientAliasId: string;
  token: string;
}): Promise<clientType.IgetPointsOfSaleAssociationsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/get_point_of_sale_associations`, {
      client_alias_id: clientAliasId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const associatePointsOfSaleAPI = async (
  psToAssociate: TPointsOfSaleToUpdateRequest[],
  aliasId: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      alias_id: aliasId,
      items: psToAssociate,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/brand_profile/associate_point_of_sale`,
    params
  );
  return await safeJsonParse(response);
};

export const detachPointOfSaleAPI = async (
  pointOfSaleId: string,
  clientAliasId: string,
  token: string
): Promise<any> => {
  const params = {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/brand_profile/delete_point_of_sale_association`, {
      point_of_sale_id: pointOfSaleId,
      client_alias_id: clientAliasId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const getClientContactsAPI = async ({
  clientId,
  token,
}: {
  clientId: string;
  token: string;
}): Promise<clientType.IgetClientContactsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/client_profile/get_client_contacts`, {
      client_id: clientId,
    }),
    params
  );
  return await safeJsonParse(response);
};

export const getBrandSegmentationsAPI = async (
  brandId: string,
  token: string
): Promise<clientType.IGetBrandSegmentationsAPIResponse> => {
  const params = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };
  const response = await fetch(
    buildUrl(`${getBasePath()}/segmentation/get_segmentations`, { brand_id: brandId }),
    params
  );
  return await safeJsonParse(response);
};

export const searchClientsAPI = async (
  body: clientType.TsearchClientBody,
  signal: AbortSignal,
  token: string
): Promise<clientType.TsearchClientsAPIResponse> => {
  const params = {
    method: 'POST',
    signal,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  };
  const response = await fetch(`${getBasePath()}/client/search`, params);
  return await safeJsonParse(response);
};

export const getExchangeRateAPI = async ({
  clientAliasPointOfSaleIds,
  token,
}: {
  clientAliasPointOfSaleIds: Array<string>;
  token: string;
}): Promise<clientType.IgetExchangeRateAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      client_alias_point_of_sale_ids: clientAliasPointOfSaleIds,
    }),
  };
  const response = await fetch(`${getBasePath()}/exchange/get_exchange_rate`, params);
  return await safeJsonParse(response);
};

export const updateExchangeRateAPI = async ({
  exchangeRateId,
  updateBody,
  token,
}: {
  exchangeRateId: string;
  updateBody: {
    end: string | null;
    rate: number;
  };
  token: string;
}): Promise<{
  response: Response;
  data: Array<clientType.IgetExchangeRateAPIResponseItem>;
}> => {
  const params = {
    method: 'PATCH',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: exchangeRateId,
      update: updateBody,
    }),
  };
  const response = await fetch(`${getBasePath()}/exchange/update_exchange`, params);
  return await safeJsonParse(response);
};

export const addNewExchangeRateAPI = async ({
  newRate,
  token,
}: {
  newRate: Array<clientType.InewRateProps>;
  token: string;
}): Promise<clientType.IaddNewExchangeRateAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      rates: newRate,
    }),
  };
  const response = await fetch(`${getBasePath()}/exchange/add_exchange_rate`, params);
  return await safeJsonParse(response);
};

export const assignCategoriesAPI = async ({
  pointOfSaleId,
  categories,
  token,
}: {
  pointOfSaleId: string;
  categories: string[];
  token: string;
}): Promise<clientType.IassignCategoriesAPIResponse> => {
  const params = {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      client_alias_point_of_sale_id: pointOfSaleId,
      category_ids: categories,
    }),
  };
  const response = await fetch(
    `${getBasePath()}/point_of_sale_profile/assign_client_alias_point_of_sale_category`,
    params
  );
  return await safeJsonParse(response);
};
